// Centralized property type and sub-type definitions
// Keep these values aligned with database CHECK constraints

export const PROPERTY_TYPES = [
  "Residential",
  "Commercial",
  "Industrial",
  "Mixed Use",
  "Retail",
  "Office",
  "Warehouse",
  "Healthcare",
  "Educational",
  "Other",
] as const;

export type PropertyType = typeof PROPERTY_TYPES[number];

export const PROPERTY_SUB_TYPES: Record<string, string[]> = {
  Residential: [
    "Single Family Home",
    "Condominium",
    "Townhouse",
    "Apartment Building",
    "Duplex/Triplex",
    "Mobile Home",
    "Other",
  ],
  Commercial: [
    "Office Building",
    "Retail Space",
    "Warehouse",
    "Hotel",
    "Restaurant",
  ],
  "Mixed Use": [
    "Residential/Commercial",
    "Office/Retail",
    "Mixed Development",
    "Live/Work",
  ],
  Industrial: [
    "Manufacturing",
    "Distribution Center",
    "Warehouse",
    "Factory",
    "Research & Development",
  ],
  Retail: [
    "Shopping Center",
    "Strip Mall",
    "Department Store",
    "Specialty Store",
  ],
  Office: [
    "High Rise",
    "Mid Rise",
    "Low Rise",
    "Medical Office",
    "Corporate Campus",
  ],
};

// Some DBs require a sub-type when the type is Residential
export const isSubtypeRequired = (type?: string | null) => type === "Residential";

export const isValidSubtype = (type: string, sub?: string | null) => {
  if (!sub) return false;
  const list = PROPERTY_SUB_TYPES[type];
  return Array.isArray(list) ? list.includes(sub) : true;
};
